(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kyndeo-campaign-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.k3d-campaign-video[data-k3d-campaign-autoplay="true"] video';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const bindVideos = (root = document) => {
      if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

      root.querySelectorAll(selector).forEach((video) => {
        if (video.dataset.k3dCampaignBound === 'true') return;
        video.dataset.k3dCampaignBound = 'true';
        video.muted = true;
        video.playsInline = true;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !reducedMotion.matches) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { rootMargin: '140px 0px', threshold: 0.3 });

        observer.observe(video);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindVideos(document), { once: true });
    } else {
      bindVideos(document);
    }

    document.addEventListener('shopify:section:load', (event) => bindVideos(event.target));
    reducedMotion.addEventListener('change', (event) => {
      if (event.matches) {
        document.querySelectorAll(selector).forEach((video) => video.pause());
      } else {
        bindVideos(document);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyndeo-fall-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.k3d-fall-video[data-k3d-autoplay="true"] .k3d-fall-video__media';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const bindVideos = (root = document) => {
      if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

      root.querySelectorAll(selector).forEach((video) => {
        if (video.dataset.k3dBound === 'true') return;
        video.dataset.k3dBound = 'true';
        video.muted = true;
        video.playsInline = true;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !reducedMotion.matches) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { rootMargin: '180px 0px', threshold: 0.18 });

        observer.observe(video);
      });
    };

    const initialize = () => bindVideos(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => bindVideos(event.target));
    reducedMotion.addEventListener('change', (event) => {
      if (event.matches) {
        document.querySelectorAll(selector).forEach((video) => video.pause());
      } else {
        bindVideos(document);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyndeo-matching-sets"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-kmax-set-button]');
    if (!button) return;
    var rawIds = button.getAttribute('data-variant-ids') || '';
    var variantIds = rawIds.split(',').filter(function(id) { return id; });
    if (!variantIds.length) return;
    event.preventDefault();
    if (button.classList.contains('is-loading')) return;
    var loadingText = button.getAttribute('data-loading-text') || 'Adding set...';
    button.classList.add('is-loading');
    button.textContent = loadingText;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: variantIds.map(function(id) {
          return { id: Number(id), quantity: 1 };
        })
      })
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function() {
        var cartUrl = button.getAttribute('data-cart-url') || '/cart';
        var discountCode = button.getAttribute('data-discount-code') || '';
        if (discountCode) {
          window.location.href = cartUrl + '?discount=' + encodeURIComponent(discountCode);
        } else {
          window.location.href = cartUrl;
        }
      })
      .catch(function() {
        window.location.href = button.href;
      });
  });

  } catch(e) { console.error(e); }
})();
})();
